export default __webpack_public_path__ + "static/media/15_tag_with-kitchen.3f3997c0.svg";